import { Inject, Injectable } from '@angular/core';
import { MediaRequestModel } from '../../helpers/objects/request/media/media-request-model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { map, Observable } from 'rxjs';
import { MediaResponseModel } from '../../helpers/objects/response/media/media-response-model';
import { MediaDigitalArchiveRequestModel } from '../../helpers/objects/request/media-digital-archive/media-digital-archive-request-model';
import { MediaDigitalArchiveResponseModel } from '../../helpers/objects/response/media-digital-archive/media-digital-archive-response-model';
import { ArticlesRequestModel } from '../../helpers/objects/request/articles/articles-request-model';
import { ArticlesResponseModel } from '../../helpers/objects/response/articles/articles-response-model';
import { ArticlesModel } from '../../helpers/objects/dto/articles/articles-model';

@Injectable({
  providedIn: 'root'
})
export class ContentsService {
  appConfig: EnvironmentModel = new EnvironmentModel();
  private selectedApi : string = '';

  constructor(private http: HttpClient, @Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel) {
    this.appConfig = appConfigTemp;

    if(this.appConfig.platform === 'fhps'){
      this.selectedApi = this.appConfig.api + 'external/'
    } else {
      this.selectedApi = this.appConfig.api
    }
  }

  getMedia(filter: MediaRequestModel): Observable<MediaResponseModel> {
    const httpParams: HttpParams = new HttpParams({
      fromObject: filter as any
    });

    return this.http
      .get<any>(this.selectedApi + 'setup/medias/' + this.appConfig.apiPartnershipId, {
        params: httpParams
      })
      .pipe(map((response) => response.body as MediaResponseModel));
  }

  getMediaDigitalArchive(documentId: string, download: boolean): Observable<MediaDigitalArchiveResponseModel> {
    const filter: MediaDigitalArchiveRequestModel = new MediaDigitalArchiveRequestModel();
    filter.Authorization = sessionStorage.getItem('token') ?? '';
    if (download) {
      filter.digitalArchiveContentId = documentId;
    } else {
      filter.digitalArchivePresentationImageId = documentId;
    }

    const httpParams: HttpParams = new HttpParams({
      fromObject: filter as any
    });

    return this.http
      .get<any>(this.appConfig.api + 'setup/medias/' + this.appConfig.apiPartnershipId + '/content', {
        params: httpParams
      })
      .pipe(map((response) => response.body as MediaDigitalArchiveResponseModel));
  }

  getArticles(filter: ArticlesRequestModel): Observable<ArticlesResponseModel> {
    const httpParams: HttpParams = new HttpParams({
      fromObject: filter as any
    });

    return this.http
      .get<any>(this.appConfig.api + 'articles/' + this.appConfig.apiPartnershipId, {
        params: httpParams
      })
      .pipe(map((response) => response.body as ArticlesResponseModel));
  }

  getDetails(id: string): Observable<ArticlesModel> {
    return this.http
      .get<any>(this.appConfig.api + 'articles/' + this.appConfig.apiPartnershipId + '/' + id)
      .pipe(map((response) => response.body as ArticlesModel));
  }
}
